var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visibleSpan)?_c('p',{staticClass:"opc-zmone__desc",class:{ 'is-warning': _vm.warning },attrs:{"role":_vm.warning ? 'alert' : 'none'}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}}),_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }